import React from "react";
import { Link } from "react-router-dom";

export default function About() {
  return (
    <div data-testid="public-about" className="max-w-2xl">
      <div className="overline-warm mb-4">About</div>
      <h1 className="display-lg mb-8">Elle Stuart</h1>

      <figure className="about-portrait mb-10" data-testid="about-portrait">
        <img src="/images/scholar-orc-transparent.png"
             alt="Five young orc children gathered around a writer's table, pressed together in mock-innocent alarm, asking 'Who Us?' as if caught red-handed — an ink pot, quill, and potted plant sit on the desk beside them."
             className="about-portrait-img"/>
        <figcaption className="about-portrait-caption">
          The suspects, assembled. None of them will admit to starting the manuscript.
        </figcaption>
      </figure>

      <div className="prose-warm space-y-5">
        <p>
          Elle Stuart is a British novelist and poet. <em>Orc in the Machine</em>,
          the first book in <em>The Boggin Chronicles</em>, is complete at
          128,000 words. Book Two is in progress. The series is planned across
          six volumes, with frameworks and detailed scenes developed for the
          full arc and a selection of character origin short stories already
          written.
        </p>
        <p>
          Poetry has been submitted to the Keats-Shelley Prize and the Bridport
          Prize. Elle also writes essays on AI, markets, and publishing —
          collected at <Link to="/essays" className="link-warm">/essays</Link>.
        </p>
        <p>
          Elle writes under a pen name. The person behind the pen name is
          Gabrielle Stuart, who works professionally as a database deployment
          specialist, which may explain the novel about administrative systems
          that fail when they encounter genuine goodness.
        </p>
        <p className="muted">
          Elle maintains a deliberately small public footprint for reasons of
          personal safety. Correspondence is welcome via the{" "}
          <Link to="/contact" className="link-warm">contact form</Link>;
          social presence is limited to{" "}
          <a href="https://bsky.app/profile/bigboggin.bsky.social"
             target="_blank" rel="noreferrer" className="link-warm">
            Bluesky
          </a>.
        </p>
      </div>
    </div>
  );
}
